import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createTagVisibleSelector } from "../../store/selectors";
import { setTagVisible } from "../../store/actions";
import SwitcherEntry from "../switcher/SwitcherEntry";
export function TagSwitcherEntry({ featureSourceId, tagGroup, tagName, }) {
    const dispatch = useDispatch();
    const visibility = useSelector(createTagVisibleSelector(featureSourceId, tagGroup, tagName));
    const toggleActive = useCallback(() => dispatch(setTagVisible(featureSourceId, tagGroup, tagName, !visibility)), [dispatch, featureSourceId, tagGroup, tagName, visibility]);
    return (_jsx(SwitcherEntry, { title: tagName, active: visibility, toggleActive: toggleActive }));
}
